import { makeStyles, fade } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  tabs: {
    minHeight: 36,
    borderBottom: `1px solid ${fade(theme.palette.primary.main, 0.16)}`,
  },
  indicator: {
    backgroundColor: theme.palette.primary.light,
  },
  tab: {
    minHeight: 36,
    minWidth: 0,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    textTransform: 'none',
    '&.Mui-selected': {
      color: theme.palette.primary.light,
    },
  },
}))

export default useStyles
